import styled from '@emotion/styled';
import { type FC } from 'react';

import { media } from '@/styles';
import { Item, type Props as ItemProps } from './item';

type Props = {
  className?: string;
  menus: ItemProps[];
};

export const MenuList: FC<Props> = ({ className, menus }) => (
  <Wrapper className={className || ''}>
    {menus.map((menu, index) => (
      <Item key={`header-menu-${index}`} {...menu} />
    ))}
  </Wrapper>
);

const Wrapper = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  gap: 0.5em;
  ${media.ipadVerticalOrMore} {
    gap: 1em;
  }
`;

export default MenuList;
